module.exports = __webpack_public_path__ + "img/101.38b8f309.svg";